<script>
import MobileLayout from '@layouts/mobile.vue';
import { breakpointsMixin } from '@mixins/breakpointsMixin';
import ProgressMobile from '@components/progress/progress-mobile.vue';
import { authComputed, authMethods, homeComputed, homeMethods, workoutComputed, workoutMethods } from '@state/helpers';

export default {
  components: {
    MobileLayout,
    ProgressMobile,
  },
  mixins: [breakpointsMixin],
  props: {},
  data() {
    return {
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    if (!this.homeOverview) {
      await this.getHomeOverview();
    }
    if (!this.progressDetails) {
      await this.getProgressDetails();
    }
    this.loading = false;
    this.setIsLoadingProgress(false);
  },
  methods: {
    ...authMethods,
    ...homeMethods,
    ...workoutMethods,
  },
  computed: {
    ...authComputed,
    ...homeComputed,
    ...workoutComputed,
  },
};
</script>

<template>
  <div>
    <MobileLayout>
      <div v-if="loading || isLoadingProgress" class="loading-wrapper">
        <BaseLoadingSpinner />
      </div>
      <ProgressMobile v-if="homeOverview && progressDetails && !loading && !isLoadingProgress" />
    </MobileLayout>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable no-descending-specificity
.loading-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 30vh;
  position: absolute;
  width: 100%;

  ::v-deep .loading {
    height: 5rem;
    width: 5rem;
  }
}
</style>
